ACC.cartremoveitem = {
  $productCtn: $('.product-ctn span'),
  $punchOutValue: document.querySelector('.punchoutStatus'),

  bindAll: function() {
    if ($('.ph-cartlinks').length > 0) {
      this.bindCartRemoveProduct();
    }
  },
  bindCartRemoveProduct: function() {
    $('.submitRemoveProduct').click(function() {
      // Fix for unique ids
      var prodid = $(this).attr('id').split('_');

      prodid = prodid[1];

      var productCode = $('#updateCartForm' + prodid).get(0).productCode.value,
          initialCartQuantity = $('#updateCartForm' + prodid).get(0).initialQuantity.value;

      ACC.cartremoveitem.trackRemoveFromCart(productCode, initialCartQuantity);
      ACC.cartremoveitem.trackDeleteGoogleAnalytics(prodid);

      $('#updateCartForm' + prodid).get(0).quantity.value = 0;
      $('#updateCartForm' + prodid).get(0).initialQuantity.value = 0;
      $('#updateCartForm' + prodid).get(0).submit();
    });


    $('.ph-updateQuantityProduct ').click(function() {
      // Fix for unique ids
      var prodid = $(this).attr('id').split('_');

      prodid = prodid[1];


      var productCode = $('#updateCartForm' + prodid).get(0).productCode.value,
          initialCartQuantity = $('#updateCartForm' + prodid).get(0).initialQuantity.value,
          newCartQuantity = $('#updateCartForm' + prodid).get(0).quantity.value;

      ACC.cartremoveitem.trackUpdateCart(productCode, initialCartQuantity, newCartQuantity);

      $('#updateCartForm' + prodid).get(0).submit();

      var desc = 'quantity:' + newCartQuantity;

      ACC.omniture.bindTrackConversion('interaction', desc);
    });

    $('.ph-edit_productquantity').click(function() {
      /*  Fix for unique ids*/
      var prodidcode = $(this).attr('id').split('_'),
          productid = prodidcode[1],
          prodQty = $('#prodQuantity_' + productid).val(),
          maxHgth = '300px';

      $('#prodCodeVal').val($('#prodCode_' + productid).val());
      $('#prodQuantityVal').val(prodQty);
      $('#prodIdVal').val(productid);
      $('#prodId' + productid).attr('src', $('#prodUrl_' + productid).find('.ph-freqorderedproduct__image').attr('src'));
      $('#prodId' + productid).attr('alt', $('#prodUrl_' + productid).find('.ph-freqorderedproduct__image').attr('alt'));
      $('#prodId' + productid).attr('title', $('#prodUrl_' + productid).find('.ph-freqorderedproduct__image').attr('title'));
      $('#prodName' + productid).html($('#prodName_' + productid).html());
      $('#unitPrice' + productid).html($('#product-unit-price-' + productid).text());
      $('#materialName' + productid).html($('#prodCode_' + productid).val());
      $('#prodCtn' + productid).html($('#prodCtn_' + productid).html());
      $('#quantity' + productid).val(prodQty);
      $('#prodCountAmt' + productid).html(prodQty + ' &times ' + $('#product-unit-price-' + productid).text());
      $('#prodTotalAmt' + productid).html($('#prodTotalPrice_' + productid).text());

      if ($(window).width() < 450) {
        maxHgth = '80%';
      }

      $.colorbox({
        inline: true,
        height: '80%',
        maxHeight: maxHgth,
        maxWidth: '742px',
        width: '100%',
        close: '',
        href: '#ph-edit_quantity_popup_' + productid
      });
    });

    $('.ph-qtydet__block__action--save').click(function() {
      var prodsaveid = $(this).attr('id').split('_'),
          produid = prodsaveid[1],
          prodQty = $('#prodQuantity_' + produid).val(),
          productCode = $('#prodCode_' + produid).val(),
          initialCartQuantity = prodQty,
          newCartQuantity = $('#quantity' + produid).val();

      $('#quantity' + produid).val(newCartQuantity);
      ACC.cartremoveitem.trackUpdateCart(productCode, initialCartQuantity, newCartQuantity);

      $('#updateCartForm' + produid).get(0).submit();

      var description = 'pop_up:button:quantity_' + newCartQuantity + ':save';

      ACC.omniture.bindTrackConversion('interaction', description);
    });

    $('.ph-qtydet__block__action--cancel').click(function() {
      ACC.omniture.bindTrackConversion('interaction', 'pop_up:button:cancel');
      $.colorbox.close();
    });
  },

  getProductObjectGoogleAnalytics: function(prodid) {
    var gaproductclass = '#ga_cartitems_' + prodid,
        locale = window.eddlContext.locale.code;

    var product = {
      id: $(gaproductclass).find('.ga_cartitem_code').text(),
      locale: locale,
      quantity: parseInt($(gaproductclass).find('.ga_cartitem_qty').text(), 10)
    };

    if ($('.ga_isanonymous').text() !== 'true' && $(gaproductclass).find('.ga_cartitem_price').text()) {
      product.price = parseFloat($(gaproductclass).find('.ga_cartitem_price').text());
    }

    return product;
  },
  trackReturnRequisitonGoogleAnalytics: function(prodindex, totalCartItems) {
    var currencyCode = window.eddlContext.locale.currency,
        eddlAction = {},
        product = {},
        productsArray = [],
        index = 0;

    for (index = prodindex; index < totalCartItems; index = index + 1) {
      product = ACC.cartremoveitem.getProductObjectGoogleAnalytics(index);
      productsArray.push(product);
    }

    eddlAction = ACC.cartremoveitem.eddlActionObjReturn(currencyCode, productsArray);
    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },

  eddlActionObjReturn: function(currencyCode, productsArray) {
    return {
      trigger: 'ecommerce.cart.returnRequisition',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: currencyCode,
        punchOutSession: ACC.cartremoveitem.$punchOutValue.textContent,
        return: {
          products: productsArray
        }
      }
    };
  },

  trackCancelRequisitonGoogleAnalytics: function(prodindex, totalCartItems) {
    var currencyCode = window.eddlContext.locale.currency,
        eddlAction = {},
        product = {},
        productsArray = [],
        index = 0;

    for (index = prodindex; index < totalCartItems; index = index + 1) {
      product = ACC.cartremoveitem.getProductObjectGoogleAnalytics(index);
      productsArray.push(product);
    }

    eddlAction = ACC.cartremoveitem.eddlActionObjCancel(currencyCode, productsArray);
    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },

  eddlActionObjCancel: function(currencyCode, productsArray) {
    return {
      trigger: 'ecommerce.cart.cancelRequisition',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: currencyCode,
        punchOutSession: ACC.cartremoveitem.$punchOutValue.textContent,
        cancel: {
          products: productsArray
        }
      }
    };
  },

  trackClearCartGoogleAnalytics: function(prodindex, totalCartItems) {
    var currencyCode = window.eddlContext.locale.currency,
        eddlAction = {},
        product = {},
        productsArray = [],
        index = 0;

    for (index = prodindex; index < totalCartItems; index = index + 1) {
      product = ACC.cartremoveitem.getProductObjectGoogleAnalytics(index);
      productsArray.push(product);
    }

    eddlAction = ACC.cartremoveitem.eddlActionObj(currencyCode, productsArray);
    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },

  trackDeleteGoogleAnalytics: function(prodindex) {
    var currencyCode = window.eddlContext.locale.currency,
        eddlAction = {},
        product = {},
        productsArray = [];

    product = ACC.cartremoveitem.getProductObjectGoogleAnalytics(prodindex);
    productsArray.push(product);
    eddlAction = ACC.cartremoveitem.eddlActionObj(currencyCode, productsArray);
    window.eddlEvents = window.eddlEvents || [];
    window.eddlEvents.push(eddlAction);
  },

  eddlActionObj: function(currencyCode, productsArray) {
    return {
      trigger: 'ecommerce.cart.remove',
      event: 'ecommerceEvent',
      ecommerce: {
        currencyCode: currencyCode,
        punchOutSession: ACC.cartremoveitem.$punchOutValue.textContent,
        remove: {
          products: productsArray
        }
      }
    };
  },

  trackRemoveFromCart: function(productCode, initialCartQuantity) {
    if (window.mediator) {
      window.mediator.publish('trackRemoveFromCart', {
        productCode: productCode,
        initialCartQuantity: initialCartQuantity
      });
    }
  },

  trackUpdateCart: function(productCode, initialCartQuantity, newCartQuantity) {
    if (window.mediator) {
      window.mediator.publish('trackUpdateCart', {
        productCode: productCode,
        initialCartQuantity: initialCartQuantity,
        newCartQuantity: newCartQuantity
      });
    }
  }

};

$(document).ready(function() {
  ACC.cartremoveitem.bindAll();
});

$('.ph-share-button').on('click', function() {
  var popupWidth = '100%',
      $shareCartInput = $('.ph-sharecart-input');

  if ($(window).width() < 768) {
    popupWidth = '90%';
  }

  $.ajax({
    type: 'POST',
    url: ACC.config.contextPath + '/cart/shareCart',
    success: function(result) {
      if (result) {
        $shareCartInput.val(result);
      }

      $.colorbox({
        inline: true,
        href: '#share-popup',
        scrolling: false,
        height: 'auto',
        width: popupWidth,
        maxWidth: 667,
        overlayClose: true,
        close: '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
        onComplete: function() {
          var cboxOppId = '#cboxContent .ph-oppId';

          $(cboxOppId).val('');

          $(document).on('click', '.ph-share-continue', function() {
            var $shareInput = $('.ph-sharecart-input'),
                oppIdValue = '',
                dataObj = {};

            if ($('#cboxLoadedContent .ph-oppId').length > 0) {
              oppIdValue = $('#cboxLoadedContent .ph-oppId').val().trim();

              if (oppIdValue.length > 0) {
                dataObj = {
                  opportunityId: oppIdValue,
                  code: $('.ph-sharecart-input').val().split('/').pop()
                };

                $.ajax({
                  type: 'POST',
                  url: ACC.config.contextPath + '/cart/updateOpportunityId',
                  data: dataObj
                });
              }
            }

            var opportunityId = $(cboxOppId).val();

            $(cboxOppId).val(opportunityId);

            $shareInput.val($shareInput.val()).select();
            document.execCommand('copy');
            $.colorbox.close();
          });

          $(document).on('click', '.ph-share-cancel', function() {
            $.colorbox.close();
          });

          ACC.common.refreshScreenReaderBuffer();
          $('#colorbox').css('border-radius', '3px');
        },
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    }
  });
});

$('.clearcart').click(function() {
  var popupWidth = '100%';

  if ($(window).width() < 768) {
    popupWidth = '90%';
  }

  $.colorbox({
    inline: true,
    href: '#clearCartPopup',
    scrolling: false,
    height: 'auto',
    width: popupWidth,
    maxWidth: 400,
    overlayClose: true,
    close: '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
    onComplete: function() {
      ACC.common.refreshScreenReaderBuffer();
      $('#colorbox').css('border-radius', '3px');
    },
    onClosed: function() {
      ACC.common.refreshScreenReaderBuffer();
    }
  });
});
$('.clearcart-comfirmpopup-clear').click(function() {
  $.colorbox.close();
});

$(document).on('click', '#colorbox .yesButton', function() {
  $('#clearCart').submit();

  var ctnArray = [],
      totalCartItems = ACC.cartremoveitem.$productCtn.length;

  ACC.cartremoveitem.trackClearCartGoogleAnalytics(0, totalCartItems);

  $(ACC.cartremoveitem.$productCtn).each(function() {
    ctnArray.push($(this).html());
  });

  var productCode = ctnArray.toString().replace(/,/g, ',;');

  if (philips && philips.analytics && typeof philips.analytics.trackAjax === 'function') {
    philips.analytics.trackAjax({
      events: 'scRemove',
      products: productCode,
      type: 'o'
    });
  }
});

$(document).on('click', '.ph-punchout__checkouttagging', function() {
  var totalCartItems = ACC.cartremoveitem.$productCtn.length;

  ACC.cartremoveitem.trackReturnRequisitonGoogleAnalytics(0, totalCartItems);
});

$(document).on('click', '.ph-punchout__canceltagging', function() {
  var totalCartItems = ACC.cartremoveitem.$productCtn.length;

  ACC.cartremoveitem.trackCancelRequisitonGoogleAnalytics(0, totalCartItems);
});

$(document).on('focus', '#colorbox .ph-qtydet__block__thrd .ph-qtydet__block__thrd--input', function() {
  var loadVal = $(this).val();

  $(this).keyup($.debounce(700, false, function() {
    var ctn = $(this).attr('data-productid'),
        quantity = $(this).val(),
        fluctuation = '';

    if (quantity > loadVal) {
      fluctuation = 'increase';
    } else {
      fluctuation = 'decrease';
    }

    if (quantity !== loadVal) {
      var desc = ctn + ':' + quantity + ':' + fluctuation;

      ACC.omniture.bindTrackConversion('interaction', desc);
    }
  }));
});
